export const Note = {
  bank_account_registration_date: '※記入例 2021/3/3',
  identification: [
    '※最大5枚までアップロード可能です。',
    `※最大アップロードする画像は、
【運転免許証（表裏両面、裏書がなくても両面必須）】
【パスポート（顔写真のページ、所持人記入ページ必須）※発行年月日が2020年2月4日以降のものは不可】
【健康保険資格確認書（裏面に現住所記載のうえ両面必須）※「記号」「番号」「保険者番号」「QRコード」の部分は付箋等でマスキングして撮影してください。】
【マイナンバーカード（顔写真側のみ）】※裏面は撮影不可【在留カード】【学生証（裏面に有効期限記載がある場合は両面必須）】`
  ], // 本人確認書類
  contract_documents: '※最大5枚までアップロードが可能です。', // エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等
  parental_consent: '※最大2枚までアップロードが可能です。', // 親権者同意書
  beri_timing_soon: '※審査後15分以内にお電話いたします。',
  beri_timing_specify: '※平日は9:00～19:00<br>土日祝日は9:00～18:00の間で指定してください。'
}

/**
 * 口座名義人の選択肢(信販)
 */
export const CreditBankAccountHolder = [
  {key: '', label: '本人', value: '本人'},
  {key: '', label: '旧姓', value: '旧姓'},
  {key: '', label: '配偶者', value: '配偶者'}
]

/**
 * 口座名義人の選択肢(自社割賦)
 */
export const InstallmentBankAccountHolder = [
  {key: '', label: '本人', value: '本人'},
  {key: '', label: '旧姓', value: '旧姓'},
  {key: '', label: '配偶者', value: '配偶者'},
  {key: '', label: '親権者', value: '親権者'}
]

/**
 * 口座名義人の選択肢
 */
export const BankAccountRegistration = [
  {key: '', label: 'A済', value: 'A済'},
  {key: '', label: 'A予定', value: 'A予定'},
  {key: '', label: '口座記入済', value: '口座記入済'},
  {key: '', label: '口座記入予定', value: '口座記入予定'}
]

/**
 * 確認日時の選択肢
 */
export const BeriTiming = [
  {key: '', label: '審査後すぐ', value: '審査後すぐ'},
  {key: '', label: '指定日時選択', value: '指定日時選択'},
  {key: '', label: '完了済', value: '完了済'}
]

/**
 * 指定日時の選択肢
 */
export const beriAtBusinessDays = [
  // 営業日
  {key: '', label: '09:00 〜 09:30', value: '09:00'},
  {key: '', label: '09:30 〜 10:00', value: '09:30'},
  {key: '', label: '10:00 〜 10:30', value: '10:00'},
  {key: '', label: '10:30 〜 11:00', value: '10:30'},
  {key: '', label: '11:00 〜 11:30', value: '11:00'},
  {key: '', label: '11:30 〜 12:00', value: '11:30'},
  {key: '', label: '12:00 〜 12:30', value: '12:00'},
  {key: '', label: '12:30 〜 13:00', value: '12:30'},
  {key: '', label: '13:00 〜 13:30', value: '13:00'},
  {key: '', label: '13:30 〜 14:00', value: '13:30'},
  {key: '', label: '14:00 〜 14:30', value: '14:00'},
  {key: '', label: '14:30 〜 15:00', value: '14:30'},
  {key: '', label: '15:00 〜 15:30', value: '15:00'},
  {key: '', label: '15:30 〜 16:00', value: '15:30'},
  {key: '', label: '16:00 〜 16:30', value: '16:00'},
  {key: '', label: '16:30 〜 17:00', value: '16:30'},
  {key: '', label: '17:00 〜 17:30', value: '17:00'},
  {key: '', label: '17:30 〜 18:00', value: '17:30'},
  {key: '', label: '18:00 〜 18:30', value: '18:00'},
  {key: '', label: '18:30 〜 19:00', value: '18:30'}
]

export const beriAtHolidays = [
  // 土日祝
  {key: '', label: '09:00 〜 09:30', value: '09:00'},
  {key: '', label: '09:30 〜 10:00', value: '09:30'},
  {key: '', label: '10:00 〜 10:30', value: '10:00'},
  {key: '', label: '10:30 〜 11:00', value: '10:30'},
  {key: '', label: '11:00 〜 11:30', value: '11:00'},
  {key: '', label: '11:30 〜 12:00', value: '11:30'},
  {key: '', label: '12:00 〜 12:30', value: '12:00'},
  {key: '', label: '12:30 〜 13:00', value: '12:30'},
  {key: '', label: '13:00 〜 13:30', value: '13:00'},
  {key: '', label: '13:30 〜 14:00', value: '13:30'},
  {key: '', label: '14:00 〜 14:30', value: '14:00'},
  {key: '', label: '14:30 〜 15:00', value: '14:30'},
  {key: '', label: '15:00 〜 15:30', value: '15:00'},
  {key: '', label: '15:30 〜 16:00', value: '15:30'},
  {key: '', label: '16:00 〜 16:30', value: '16:00'},
  {key: '', label: '16:30 〜 17:00', value: '16:30'},
  {key: '', label: '17:00 〜 17:30', value: '17:00'},
  {key: '', label: '17:30 〜 18:00', value: '17:30'}
]
